import {SvgIconData} from '@shared_web/components/core/svg_icon';

import {TEXT_MAIN_COLOR} from '@mavismart_frontend/lib/constants';

export const icon_arrow_left: SvgIconData = {
  viewBox: '0 0 18 14',
  element: (
    <path
      d="M7.33333 12.8333L1.5 6.99999M1.5 6.99999L7.33333 1.16666M1.5 6.99999L16.5 6.99999"
      stroke={TEXT_MAIN_COLOR}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
